import ApiTable from "components/ApiTable";
import { Card, CardList } from "components/Card";
import CSVDownload from "components/CSVDownload";
import ExportActionButton from "components/ExportActionButton";
import FileEditorModal from "components/FileEditorModal";
import Loader from "components/Loader";
import Config from "config";
import { RouteProps } from "containers/App";
import CreateBreadcrumb from "containers/CreateBreadcrumb";
import FileUpload from "containers/FileUpload";
import ManageDataPreview from "containers/ManageDataPreview";
import { SORTING_ORDER } from "enum/sorting.enum";
import Constants from "helpers/constants";
import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import { deleteUser } from "state/user";
import {
  exportUsersCsv,
  fetchUsers,
  filterUsers,
  getRegions,
  patchUser,
  saveUser,
} from "state/users";
import { buildExportFilename, getTemplateHeaders } from "utils/helpers";
import DeleteIcon from "../assets/img/Delete.png";
import EditIcon from "../assets/img/Edit.png";
import Modal from "../components/LightThemeModal";
import { Store } from "../interfaces/store";
import { getRoles } from "../state/chain_user_role";

type ManageUsersProps = PropsFromRedux & RouteProps;
interface ManageUsersState {
  email: string | null;
  firstname: string;
  lastname: string;
  phone: string;
  userTitle: string;
  company: string;
  title: string;
  employer: string;
  region: string;
  wholesaler_numbers: string;
  irisAccess: number;
  irisEmail: number;
  dateAdded: string;
  showWarningModal: boolean;
  showErrors: boolean;
  isContinuebtnDisplay: boolean;
  editUser: any;
  showModal: boolean;
  showPhoneError: boolean;
  roles: any;
  showWholesalerError: boolean;
  showEmailError: boolean;
  roleId: number;
  statusMessage: string;
  allUsers: any;
  deletePopoverOpenId: number;
  fileEditorOpen: boolean;
  fileEditorFile: File | null;
  fileEditorError: string | null;
  isLoading?: boolean;
  isExporting?: boolean;
  exportProgressLabel?: string;
  isAwaitingCreation?: boolean;
  page: number;
  limit: number;
  columnFilters: { [key: string]: string };
  sortField: string;
  sortOrder: SORTING_ORDER;
}
const styles = {
  container: { background: "#fff", padding: 10, borderRadius: 10 },
  header: { fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: 14, marginBottom: 15 },
  button: (bg: string, color: string, border: string = "none") => ({
    padding: "5px 15px",
    border,
    borderRadius: 4,
    backgroundColor: bg,
    color,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
  }),
  input: { width: "100%", padding: 8, borderRadius: 16, border: "1px solid #ccc", fontSize: 12 },
  modalFooter: { display: "flex", justifyContent: "flex-end", marginTop: 15 },
  confirmFooter: { display: "flex", justifyContent: "center", gap: 20 },
};

class ManageUsers extends React.Component<ManageUsersProps, ManageUsersState> {
  state = {
    email: "",
    firstname: "",
    lastname: "",
    phone: "",
    userTitle: "",
    company: "",
    title: "",
    employer: "",
    region: "",
    wholesaler_numbers: "",
    irisAccess: -1,
    irisEmail: -1,
    dateAdded: "",
    showWarningModal: false,
    showErrors: false,
    isContinuebtnDisplay: false,
    editUser: { id: -1 },
    showModal: false,
    showPhoneError: false,
    roles: [],
    showWholesalerError: false,
    showEmailError: false,
    roleId: -1,
    statusMessage: "",
    allUsers: [],
    deletePopoverOpenId: -1,
    fileEditorOpen: false,
    fileEditorFile: null,
    fileEditorError: null,
    isLoading: true,
    isExporting: false,
    exportProgressLabel: "",
    isAwaitingCreation: false,
    page: 1,
    limit: 100,
    columnFilters: {},
    sortField: "",
    sortOrder: SORTING_ORDER.DESC,
  };

  public componentDidMount() {
    this.props.fetchUsers(1, this.state.limit, this.state.sortField, this.state.sortOrder);
    this.props.getRegions();
    this.props.getRoles();
  }

  // public handleDelete(id: number) {
  //   return this.props.deleteUser(id);
  // }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.target.value });
  };

  public handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    // reset form and inputs
    this.setState({ email: "", page: 1 });
    this.props.fetchUsers(1, this.state.limit, this.state.sortField, this.state.sortOrder);
  };

  public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { email, limit, sortField, sortOrder } = this.state;
    this.setState({ page: 1 });
    this.props.filterUsers({ email, page: 1, limit, sortField, sortOrder });
  };

  handlePageChange = (page: number, pageSize: number) => {
    const { columnFilters, sortField, sortOrder } = this.state;
    this.setState({ page, limit: pageSize });
    if (Object.keys(columnFilters).length > 0) {
      this.props.filterUsers({ ...columnFilters, page, limit: pageSize, sortField, sortOrder });
    } else {
      this.props.fetchUsers(page, pageSize, sortField, sortOrder);
    }
  };

  handleColumnSearch = (field: string, value: string) => {
    const normalizedValue = (value || "").trim();
    const { limit, sortField, sortOrder } = this.state;
    const updatedFilters = { ...this.state.columnFilters } as any;

    if (normalizedValue) {
      updatedFilters[field] = normalizedValue;
    } else {
      delete updatedFilters[field];
    }

    this.setState({
      email: field === "email" ? normalizedValue : this.state.email,
      page: 1,
      columnFilters: updatedFilters,
    });

    if (Object.keys(updatedFilters).length > 0) {
      this.props.filterUsers({ ...updatedFilters, page: 1, limit, sortField, sortOrder });
    } else {
      this.props.fetchUsers(1, limit, sortField, sortOrder);
    }
  };

  handleSort = (field: string, order: SORTING_ORDER) => {
    const { columnFilters, limit } = this.state;
    this.setState({ sortField: field, sortOrder: order, page: 1 });

    if (Object.keys(columnFilters).length > 0) {
      this.props.filterUsers({
        ...columnFilters,
        page: 1,
        limit,
        sortField: field,
        sortOrder: order,
      });
    } else {
      this.props.fetchUsers(1, limit, field, order);
    }
  };

  handleExportUsers = async () => {
    const { columnFilters, sortField, sortOrder } = this.state;
    this.setState({ isExporting: true, exportProgressLabel: "Preparing export..." });
    try {
      await this.props.exportUsersCsv(
        {
          ...columnFilters,
          sortField,
          sortOrder,
        },
        ({ percent, exported, total }: { percent: number; exported: number; total: number }) => {
          if (total > 0) {
            this.setState({
              exportProgressLabel: `Exporting ${exported}/${total} (${percent}%)`,
            });
          } else {
            this.setState({ exportProgressLabel: "Exporting..." });
          }
        }
      );
    } finally {
      this.setState({ isExporting: false, exportProgressLabel: "" });
    }
  };

  handleInputChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      let value: string | number = e.target.value;
      // Convert to number for specific fields
      if (["irisAccess"].includes(field)) {
        value = Number(value);
      }

      // Special logic for irisAccess
      if (field === "irisAccess") {
        // When irisAccess = 0, clear wholesaler errors and disable its value
        if (value === 0) {
          this.setState({
            irisAccess: value,
            wholesaler_numbers: "",
            showWholesalerError: false,
          });
          return;
        }
      }
      this.setState({ [field]: e.target.value } as any);
    };

  resetForm = () =>
    this.setState({
      email: "",
      firstname: "",
      lastname: "",
      phone: "",
      userTitle: "",
      company: "",
      title: "",
      employer: "",
      region: "",
      wholesaler_numbers: "",
      irisAccess: -1,
      irisEmail: -1,
      dateAdded: "",
      showPhoneError: false,
      showWholesalerError: false,
      showEmailError: false,
      roleId: -1,
      deletePopoverOpenId: -1,
      fileEditorOpen: false,
      fileEditorFile: null,
      fileEditorError: null,
    });

  handlePhoneChange = (e: any) => {
    let value = e.target.value.replace(/\D/g, ""); // remove all non-digit characters

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Format as 123-456-7890
    let formatted = value;
    if (value.length > 6) {
      formatted = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
    } else if (value.length > 3) {
      formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
    }

    this.setState({ phone: formatted });
  };

  handleBlur = () => {
    const digits = (this.state.phone || "").replace(/\D/g, "");
    this.setState({ showPhoneError: digits.length > 0 && digits.length < 10 });
  };
  handleCreateNew = () => {
    this.setState({ showModal: true, editUser: null }, this.resetForm);
  };

  handleWholesalerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (this.state.irisAccess <= 0) return;

    // 1️⃣ Extract only digits
    const digitsOnly = e.target.value.replace(/\D/g, "");

    // 2️⃣ Break into 5-digit chunks
    const chunks = digitsOnly.match(/.{1,5}/g) || [];

    // 3️⃣ Join with SINGLE "/"
    const formatted = chunks.join("/");

    // 4️⃣ Validation
    const hasInvalid = chunks.some((chunk) => chunk.length < 5);

    // 5️⃣ Single setState → no lag, no caret jump
    this.setState({
      wholesaler_numbers: formatted,
      showWholesalerError: hasInvalid,
    });
  };

  handleWholesalerBlur = () => {
    const { wholesaler_numbers, irisAccess } = this.state;
    if (irisAccess <= 0) return;

    const chunks = wholesaler_numbers.split("/").filter(Boolean);
    const hasInvalid = chunks.some((c) => c.length < 5);

    this.setState({
      wholesaler_numbers: chunks.join("/"),
      showWholesalerError: hasInvalid,
    });
  };

  handleWholesalerPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    const pasted = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    if (!pasted) return;

    const chunks = pasted.match(/.{1,5}/g) || [];
    const formatted = chunks.map((c) => c.slice(0, 5)).join("/");

    this.setState({
      wholesaler_numbers: formatted,
      showWholesalerError: chunks.some((c) => c.length < 5),
    });
  };

  // --- Add these handlers ---
  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    this.setState({ email: value });
  };

  handleEmailBlur = () => {
    const { email } = this.state;

    // Simple but effective email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    this.setState({
      showEmailError: email.length > 0 && !emailRegex.test(email),
    });
  };

  handleSaveNew = async () => {
    const {
      firstname,
      lastname,
      phone,
      userTitle,
      company,
      title,
      employer,
      region,
      wholesaler_numbers,
      irisAccess,
      irisEmail,
      dateAdded,
      showModal,
      editUser,
      email,
      showPhoneError,
      roleId,
    } = this.state;
    this.setState({
      isAwaitingCreation: true,
    });
    if (editUser && editUser.id) {
      this.props
        .patchUser(
          {
            firstname,
            lastname,
            phone,
            userTitle,
            company,
            title,
            employer,
            region,
            wholesaler_numbers,
            irisAccess: irisAccess > 0 ? irisAccess : 0,
            irisEmail: irisEmail > 0 ? irisEmail : 0,
            dateAdded,
            email,
            roleId,
          },
          editUser.id
        )
        .then(() => {
          if (this.props.errorMessage === 410) {
            let errorMessage =
              this.props.errorMessage === 410
                ? "Please enter valid wholesale number"
                : "An error occurred.";
            this.setState({ showModal: true, isAwaitingCreation: false });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else if (this.props.errorMessage === 411) {
            let errorMessage =
              this.props.errorMessage === 411
                ? "Wholesale numbers with this user is already mapped"
                : "An error occurred.";
            this.setState({ showModal: true, isAwaitingCreation: false });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else {
            this.setState({
              isAwaitingCreation: false,
              showModal: false,
            });
            this.resetForm();
            this.props.fetchUsers(1, this.state.limit);
          }
        });
    } else {
      this.props
        .saveUser({
          firstname,
          lastname,
          phone,
          userTitle,
          company,
          title,
          employer,
          region,
          wholesaler_numbers,
          irisAccess: irisAccess > 0 ? irisAccess : 0,
          irisEmail: irisEmail > 0 ? irisEmail : 0,
          dateAdded,
          email,
          roleId,
        })
        .then(() => {
          if (this.props.errorMessage === 409) {
            let errorMessage =
              this.props.errorMessage === 409
                ? "This email address already exists."
                : "An error occurred.";
            this.setState({ showModal: true, isAwaitingCreation: false });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else if (this.props.errorMessage === 410) {
            let errorMessage =
              this.props.errorMessage === 410
                ? "Please enter valid wholesale number"
                : "An error occurred.";
            this.setState({ showModal: true, isAwaitingCreation: false });
            this.setState({ showWarningModal: true, statusMessage: errorMessage });
          } else {
            this.setState({
              isAwaitingCreation: false,
              showModal: false,
            });
            this.resetForm();
            this.props.fetchUsers(1, this.state.limit);
          }
        });
    }
  };
  formatForDatePicker = (value: string) => {
    return moment(value).format("YYYY-MM-DD");
  };

  handleEdit = (id: number, user: any) => {
    this.resetForm();
    if (!user) return;
    this.setState({
      editUser: user,
      firstname: user.firstname,
      lastname: user.lastname,
      phone: user.phone,
      userTitle: user.role_id,
      company: user.company,
      title: user.title,
      employer: user.employer,
      region: user.regin_id ? user.regin_id : "",
      irisAccess:
        user.user_level_permissions.length > 0
          ? user.user_level_permissions.includes("access_DIR")
            ? 1
            : 0
          : 0,
      wholesaler_numbers:
        user.wholesaler_numbers.length > 0 ? user.wholesaler_numbers.join("/") : "",
      irisEmail:
        user.user_level_permissions.length > 0
          ? user.user_level_permissions.includes("get_DIR_email")
            ? 1
            : 0
          : 0,
      dateAdded: this.formatForDatePicker(user.createdAt),
      email: user.email,
      showModal: true,
    });
  };

  handleDelete = (id: number, user: any, currentUser: any) => {
    if (id.toString() === (currentUser && currentUser.id.toString())) {
      return null;
    }
    this.setState({
      deletePopoverOpenId: id,
      isContinuebtnDisplay: true,
      showWarningModal: true,
      statusMessage: `Are you sure you want to delete ${user.email}?`,
    });
  };

  public handleUserDelete(id: any) {
    this.props.deleteUser(id).then(() => {
      this.resetForm();
      this.props.fetchUsers(1, this.state.limit);
      this.setState({
        isContinuebtnDisplay: false,
        showWarningModal: false,
        statusMessage: "",
      });
    });
  }

  public handleUploadError = (error: any, uploadedFile: File) => {
    // Extract error message from different possible error formats

    console.log("handleUploadError triggers", error);

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed. Please review and correct the file.";

    this.setState({
      fileEditorOpen: true,
      fileEditorFile: uploadedFile,
      fileEditorError: errorMessage,
    });
  };

  public handleFileEditorClose = () => {
    this.setState({
      fileEditorOpen: false,
      fileEditorFile: null,
      fileEditorError: null,
    });
  };

  public handleFileEditorSuccess = async () => {
    // Refresh the store list after successful edit upload
    this.props.fetchUsers(1, this.state.limit);
    // this.updateTableData();
    this.handleFileEditorClose();
  };

  public componentDidUpdate(prevProps: ManageUsersProps) {
    if (prevProps.users !== this.props.users) {
      this.setState({
        isLoading: false,
      });
    }
  }

  public render() {
    const columns = [
      {
        field: "role",
        header: "User Title",
      },
      { field: "firstname", header: "First Name" },
      { field: "lastname", header: "Last Name" },
      { field: "email", header: "Email" },
      { field: "company", header: "Company Representing" },
      {
        field: "lastLoggedIn",
        header: "Last Logged In",
        type: "date",
        formatter: (value: string) => {
          if (value) {
            return moment(value, Constants.DATE_FORMAT__YYYY_MM_DD).format("M/D/YYYY");
          } else {
            return "-";
          }
        },
      },
      {
        field: "createdAt",
        header: "Uploaded Date",
        type: "date",
        formatter: (value: string) => {
          return moment(value, Constants.DATE_FORMAT__YYYY_MM_DD).format("M/D/YYYY");
        },
      },
      {
        field: "actions",
        header: "",
        sortable: false,
        searchable: false,
        minWidth: 90,
        formatter: (_: any, row: Store) => (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 30 }}>
            <button
              onClick={() => this.handleEdit(row.id, row)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
            >
              <img src={EditIcon} alt="Edit" style={{ display: "block" }} />
            </button>
            <button
              onClick={() => this.handleDelete(row.id, row, currentUser)}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
            >
              <img src={DeleteIcon} alt="Delete" style={{ display: "block" }} />
            </button>
          </div>
        ),
      },
    ];
    const { currentUser, users = [], regions = [], roles = [], pagination } = this.props;
    const allUsers: any = users.map((each) => each);
    const {
      firstname,
      lastname,
      phone,
      userTitle,
      company,
      title,
      employer,
      region,
      wholesaler_numbers,
      irisAccess,
      irisEmail,
      dateAdded,
      showModal,
      editUser,
      email,
      showPhoneError,
      roleId,
      fileEditorOpen,
      fileEditorFile,
      fileEditorError,
    } = this.state;
    const irisOptions = [
      { id: 0, name: "False" },
      { id: 1, name: "True" },
    ];
    const formatedRegions = Array.isArray(regions)
      ? regions.map((each: any) => ({
          id: each.id,
          name: each.name,
        }))
      : [];
    const roleOptions = Array.isArray(roles)
      ? roles.map((each: any) => ({
          id: each.id,
          name: each.role,
        }))
      : [];
    return (
      <section className="manage-data-container">
        <CreateBreadcrumb
          crumbs={{
            crumbs: [
              {
                to: "/manage-all-data",
                crumb: "VIEW ALL DATA",
                dataQa: "view-all-data-link",
              },
            ],
          }}
        />
        <div className="manage-data-body">
          {/*<h1 className="header" data-qa="admin-user-header">*/}
          {/*  Manage User Data*/}
          {/*</h1>*/}
          <div className="upload-section-3">
            <h4>Upload Users</h4>
            <div>
              {/*<CSVDownload*/}
              {/*  data={this.props.users ? this.props.users.map(userToUserCSV) : []}*/}
              {/*  headers={this.CSV_HEADERS}*/}
              {/*  filename={buildExportFilename("csv", "users")}*/}
              {/*>*/}
              {/*  <div className="file-upload-header">Download CSV Template</div>*/}
              {/*</CSVDownload>*/}

              <CSVDownload
                data={[]}
                headers={getTemplateHeaders("Upload New Users")}
                filename={buildExportFilename("csv", `${"Upload New Users"}-template`)}
              >
                <div className="file-upload-header">Download CSV Template</div>
              </CSVDownload>
              <FileUpload
                prefix={"USERS"}
                url={`${Config.API_SERVICE_URL}/api/users`}
                label={""}
                dataQa={"manage-users-file-upload"}
                afterUploadFunction={this.props.fetchUsers}
                onUploadError={this.handleUploadError}
              />
            </div>
          </div>
          {/*<ul className="file-upload-list">*/}
          {/*  <li className="file-upload-item">*/}
          {/*   */}
          {/*  </li>*/}
          {/* */}
          {/*</ul>*/}
          <CardList>
            <Card>
              <ManageDataPreview prefix={"USERS"} />
            </Card>
          </CardList>
          <div className="manage-data-table-controls" data-qa="chain-dropdown">
            <div className="action-btns" style={{ marginLeft: "auto" }}>
              <div>
                <ExportActionButton
                  disabled={false}
                  onClick={this.handleExportUsers}
                  isLoading={!!this.state.isExporting}
                  loadingLabel={this.state.exportProgressLabel || "Exporting..."}
                />
              </div>
              <div>
                <button className="primary-button" onClick={this.handleCreateNew}>
                  Create New
                </button>
              </div>
            </div>
          </div>
          <CardList>
            <Card>
              {/*<Table*/}
              {/*  data={users}*/}
              {/*  emptyState={"No users found"}*/}
              {/*  columns={[*/}
              {/*    {*/}
              {/*      field: "role",*/}
              {/*      header: "USER ROLE",*/}
              {/*      dataQa: "user-role",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "email",*/}
              {/*      header: "EMAIL ADDRESS",*/}
              {/*      dataQa: "email-address",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "firstname",*/}
              {/*      header: "FIRST NAME",*/}
              {/*      dataQa: "first-name",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "lastname",*/}
              {/*      header: "LAST NAME",*/}
              {/*      dataQa: "last-name",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "company",*/}
              {/*      header: "COMPANY REPRESENTING",*/}
              {/*      dataQa: "company-representing",*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "createdAt",*/}
              {/*      header: "DATE ADDED",*/}
              {/*      dataQa: "date-added",*/}
              {/*      formatter: (value) => {*/}
              {/*        return moment(value, Constants.DATE_FORMAT__YYYY_MM_DD).format("M/D/YYYY");*/}
              {/*      },*/}
              {/*    },*/}
              {/*    {*/}
              {/*      field: "id",*/}
              {/*      header: "",*/}
              {/*      sortable: false,*/}
              {/*      dataQa: "delete-user",*/}
              {/*      formatter: (id, row, index) => {*/}
              {/*        // don't allow the user to delete themselves*/}
              {/*        if (id.toString() === (currentUser && currentUser.id.toString())) {*/}
              {/*          return null;*/}
              {/*        }*/}

              {/*        return (*/}
              {/*          <DeletePopover*/}
              {/*            message={"Delete this user"}*/}
              {/*            onConfirm={(_) => this.handleDelete(row.id)}*/}
              {/*            id={row.id}*/}
              {/*            index={index as number}*/}
              {/*          />*/}
              {/*        );*/}
              {/*      },*/}
              {/*    },*/}
              {/*  ]}*/}
              {/*/>*/}
              <div style={{ margin: "1%" }}>
                <ApiTable
                  data={allUsers}
                  columns={columns}
                  loading={this.state.isLoading}
                  pageSizeOptions={[100, 250, 500]}
                  page={this.state.page}
                  pageSize={this.state.limit}
                  total={pagination?.total || 0}
                  onSearch={this.handleColumnSearch}
                  onSort={this.handleSort}
                  onPageChange={this.handlePageChange}
                />
              </div>
            </Card>
          </CardList>
          <div>
            <Modal
              show={showModal}
              onClose={() => this.setState({ showModal: false, showErrors: false })}
              title={editUser ? "Edit User" : "User Details"}
              width="800px"
              closeOnBackdropClick={false}
              footer={
                <div style={styles.modalFooter}>
                  <div style={{ display: "flex" }}>
                    <div style={{ display: "flex", marginRight: "5px" }}>
                      {this.state.isAwaitingCreation && (
                        <Loader height={20} width={20} custom={true}></Loader>
                      )}
                    </div>
                    <button
                      onClick={() => {
                        const isValid =
                          (firstname || "").trim() &&
                          (lastname || "").trim() &&
                          (email || "").trim() &&
                          userTitle &&
                          (company || "").trim();
                        if (!isValid || irisAccess === -1) {
                          this.setState({ showErrors: true });
                          return;
                        }
                        if (
                          (irisAccess > 0 && !wholesaler_numbers) ||
                          (irisAccess > 0 && this.state.showWholesalerError)
                        ) {
                          return;
                        }
                        this.setState({ showErrors: false }, () => {
                          this.handleSaveNew();
                        });
                      }}
                      style={{
                        padding: "6px 12px",
                        borderRadius: 4,
                        background: "#E5B42F",
                        color: "#fff",
                        border: "none",
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: "pointer",
                        minWidth: "72px",
                        //marginLeft: "5px",
                      }}
                    >
                      {!this.state.isAwaitingCreation ? "Submit" : "Submitting"}
                    </button>
                  </div>
                </div>
              }
            >
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>
                    First Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={firstname}
                    onChange={this.handleInputChange("firstname")}
                    placeholder="Enter First Name"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !firstname ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !firstname && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>
                    Last Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={lastname}
                    onChange={this.handleInputChange("lastname")}
                    placeholder="Enter Last Name"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !lastname ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !lastname && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>
                    Email Address<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    value={this.state.email}
                    onChange={this.handleEmailChange}
                    onBlur={this.handleEmailBlur}
                    placeholder="Enter Email Address"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background: this.state.editUser
                        ? "#f0f0f0"
                        : this.state.showErrors && !this.state.email
                        ? "#ffe6e6"
                        : this.state.showEmailError
                        ? "#ffe6e6"
                        : "#fff",
                    }}
                    disabled={editUser ? true : false}
                  />
                  {/* Show required field error */}
                  {this.state.showErrors && !this.state.email && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                  {/* Show invalid email error */}
                  {this.state.showEmailError && this.state.email && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      Please enter a valid email address.
                    </span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", gap: 20, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>Phone</label>
                  <input
                    type="text"
                    value={phone}
                    onChange={this.handlePhoneChange}
                    onBlur={this.handleBlur}
                    placeholder="Enter Phone Number"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background:
                        this.state.showErrors && phone && showPhoneError ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {showPhoneError && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      Please enter a 10-digit phone number.
                    </span>
                  )}
                </div>
                <div style={{ flex: 1 }}>
                  <label>
                    User Title <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="select-dropdown"
                    value={userTitle}
                    onChange={this.handleInputChange("userTitle")}
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && !userTitle ? "#ffe6e6" : "#fff",
                      padding: "10px",
                      color: userTitle ? "#000" : "#999",
                    }}
                  >
                    {!userTitle && (
                      <option value="" disabled>
                        Enter user title
                      </option>
                    )}
                    {roleOptions.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.name}
                      </option>
                    ))}
                  </select>
                  {this.state.showErrors && !userTitle && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>
                    Company<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={company}
                    onChange={this.handleInputChange("company")}
                    placeholder="Enter Company"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background:
                        this.state.showErrors && !(company || "").trim() ? "#ffe6e6" : "#fff",
                    }}
                  />
                  {this.state.showErrors && !(company || "").trim() && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", gap: 18, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>Title</label>
                  <input
                    type="text"
                    value={title}
                    onChange={this.handleInputChange("title")}
                    placeholder="Enter title"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Employer</label>
                  <input
                    type="text"
                    value={employer}
                    onChange={this.handleInputChange("employer")}
                    placeholder="Enter Employer Name"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label>Region</label>
                  <select
                    value={region}
                    onChange={this.handleInputChange("region")}
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                      padding: "10px",
                      color: region ? "#000" : "#999",
                    }}
                  >
                    {region == "" && (
                      <option value="" disabled>
                        Select Region
                      </option>
                    )}
                    {formatedRegions.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", gap: 18, marginBottom: 15, fontSize: 12 }}>
                <div style={{ flex: 1 }}>
                  <label>
                    IRIS Access<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    value={this.state.irisAccess < 0 ? "" : this.state.irisAccess}
                    onChange={this.handleInputChange("irisAccess")}
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: this.state.showErrors && irisAccess < 0 ? "#ffe6e6" : "#fff",
                      padding: "10px",
                      color: irisAccess < 0 ? "#999" : "#000",
                    }}
                  >
                    {irisAccess < 0 && (
                      <option value="" disabled>
                        Enter IRIS Access
                      </option>
                    )}
                    {irisOptions.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.name}
                      </option>
                    ))}
                  </select>
                  {this.state.showErrors && irisAccess < 0 && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                </div>
                <div style={{ flex: 1 }} aria-disabled={this.state.irisAccess <= 0}>
                  <label>
                    Wholesaler Numbers
                    {this.state.irisAccess > 0 && <span style={{ color: "red" }}>*</span>}
                  </label>

                  <input
                    type="text"
                    placeholder="Enter Wholesaler"
                    value={this.state.wholesaler_numbers}
                    onChange={this.handleWholesalerChange}
                    onBlur={this.handleWholesalerBlur}
                    onPaste={this.handleWholesalerPaste}
                    disabled={this.state.irisAccess <= 0}
                    inputMode="numeric" // 📱 mobile numeric keypad
                    pattern="[0-9/]*"
                    style={{
                      ...styles.input,
                      height: "36px",
                      border: "1px solid #ccc",
                      background:
                        this.state.irisAccess <= 0
                          ? "#f0f0f0"
                          : this.state.showWholesalerError
                          ? "#ffe6e6"
                          : "#fff",
                    }}
                  />
                  {irisAccess > 0 && !wholesaler_numbers && !this.state.showWholesalerError && (
                    <span style={{ color: "red", fontSize: 12 }}>This field is required.</span>
                  )}
                  {this.state.showWholesalerError && (
                    <span style={{ color: "red", fontSize: 12 }}>
                      Please enter exactly 5 digits.
                    </span>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <label>IRIS Email</label>
                  <select
                    value={this.state.irisEmail < 0 ? "" : this.state.irisEmail}
                    onChange={this.handleInputChange("irisEmail")}
                    style={{
                      ...styles.input,
                      border: "1px solid #ccc",
                      background: "#fff",
                      padding: "10px",
                      color: irisEmail < 0 ? "#999" : "#000",
                    }}
                  >
                    {irisEmail < 0 && (
                      <option value="" disabled>
                        Enter IRIS Email
                      </option>
                    )}
                    {irisOptions.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/*<div style={{ display: "flex", gap: 18, marginBottom: 15, fontSize: 12 }}>*/}
              {/*  <div style={{ flex: 1 }}>*/}
              {/*    <label>Date Added</label>*/}
              {/*    <input*/}
              {/*      type="date"*/}
              {/*      value={dateAdded || ""}*/}
              {/*      onChange={this.handleInputChange("dateAdded")}*/}
              {/*      placeholder="Select Date"*/}
              {/*      style={{*/}
              {/*        ...styles.input,*/}
              {/*        border: "1px solid #ccc",*/}
              {/*        background: "#fff",*/}
              {/*        color: "#999",*/}
              {/*        padding: "8px 10px",*/}
              {/*        fontSize: "14px",*/}
              {/*        borderRadius: "26px",*/}
              {/*        appearance: "none",*/}
              {/*        WebkitAppearance: "none",*/}
              {/*        MozAppearance: "none",*/}
              {/*      }}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*  <div style={{ flex: 1 }}></div>*/}
              {/*  <div style={{ flex: 1 }}></div>*/}
              {/*</div>*/}
            </Modal>
          </div>
          <div>
            <Modal
              show={this.state.showWarningModal}
              onClose={() => this.setState({ showWarningModal: false })}
              title=""
              width="400px"
              footer={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    paddingTop: 10,
                  }}
                >
                  {!this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      OK
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() => this.setState({ showWarningModal: false })}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Cancel
                    </button>
                  )}

                  {this.state.isContinuebtnDisplay && (
                    <button
                      onClick={() =>
                        this.setState({ showWarningModal: false }, () =>
                          this.handleUserDelete(this.state.deletePopoverOpenId)
                        )
                      }
                      style={{
                        padding: "6px 16px",
                        borderRadius: 4,
                        border: "none",
                        background: "#E5B42F",
                        color: "#000",
                        cursor: "pointer",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Yes, Continue
                    </button>
                  )}
                </div>
              }
            >
              <p style={{ marginBottom: 20, color: "#555", fontSize: 12 }}>
                <strong>{this.state.statusMessage}</strong>
              </p>
            </Modal>
          </div>
        </div>

        {/* prefix={"USERS"}
                url={`${Config.API_SERVICE_URL}/api/users`}
                label={""}
                dataQa={"manage-users-file-upload"}
                afterUploadFunction={this.props.fetchUsers} */}

        <FileEditorModal
          isOpen={fileEditorOpen}
          file={fileEditorFile}
          error={fileEditorError}
          prefix="USERS"
          config={{
            prefix: "USERS",
            url: `${Config.API_SERVICE_URL}/api/users`,
            onUploadSuccess: this.handleFileEditorSuccess,
          }}
          onClose={this.handleFileEditorClose}
        />
      </section>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    currentUser: state.auth_user.content,
    users: state.users.content?.data,
    regions: state.users.regions,
    roles: state.chains_users_role.roles,
    errorMessage: state.users.errorMessage,
    pagination: state.users.pagination,
  }),
  { fetchUsers, deleteUser, filterUsers, getRegions, getRoles, saveUser, patchUser, exportUsersCsv }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ManageUsers);
